<section
    class="tw-bg-[#0A0A75] tw-text-white tw-relative tw-h-[500px] sm:tw-h-auto"
>
    <div
        class="tw-max-w-[1380px] tw-mx-auto tw-py-5 tw-min-h-[365px] tw-px-[15px] tw-flex tw-items-center"
    >
        <div class="tw-max-w-[650px]">
            <h1
                class="!tw-font-bold !tw-text-center sm:!tw-text-left !tw-text-[32px] sm:!tw-text-[40px] !tw-mb-6"
            >
                {{ "PARTNERS.PARTNERS_TITLE" | translate }}
            </h1>
            <p
                class="!tw-text-center !tw-text-[14px] sm:!tw-text-[16px] sm:!tw-text-left"
            >
                {{ "PARTNERS.PARTNERS_DESC" | translate }}
            </p>
        </div>
    </div>
    <img
        src="/assets/images/partnership/hero.png"
        alt="Parnership"
        class="tw-absolute tw-right-0 tw-top-0 tw-h-full tw-hidden sm:tw-block"
    />
    <img
        src="/assets/images/partnership/hero-mob.png"
        alt="Parnership"
        class="tw-absolute tw-w-full tw-h-auto tw-bottom-0 sm:tw-hidden tw-block"
    />
</section>
